export default __webpack_public_path__ + "static/media/close.c939c259.svg";